import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UnreadCountState {
  chatCount: number;
  shouldShowChatPlusPrefix: boolean;
}

const initialState: UnreadCountState = {
  chatCount: 0,
  shouldShowChatPlusPrefix: false,
};

const unreadCountSlice = createSlice({
  name: 'unreadCount',
  initialState,
  reducers: {
    setChatUnreadCount: (state, action: PayloadAction<{ count: number; shouldShowPlusPrefix: boolean }>) => {
      state.chatCount = action.payload.count;
      state.shouldShowChatPlusPrefix = action.payload.shouldShowPlusPrefix;
    },
    decreaseChatUnreadCount: (state, action: PayloadAction<number>) => {
      state.chatCount = Math.max(0, state.chatCount - action.payload);
      // Recalculate shouldShowPlusPrefix - if count becomes 0, definitely no plus prefix
      if (state.chatCount === 0) {
        state.shouldShowChatPlusPrefix = false;
      }
    },
  },
});

export const { setChatUnreadCount, decreaseChatUnreadCount } = unreadCountSlice.actions;
export default unreadCountSlice;